// Import illustrations separately
import { IllustrationType } from '../../types';
import _3dModels from './svg/3d_models.svg';
import _3dModelsGrey from './svg/3d_models_grey.svg';
import accHorizontalGrey from './svg/acc_horizontal_grey.svg';
import accHorizontalWhite from './svg/acc_horizontal_white.svg';
import accHorizontalWhiteNew2022 from './svg/acc_horizontal_white_new_2022.svg';
import accIconBlue from './svg/acc_icon_blue.svg';
import accMark from './svg/acc_mark.svg';
import accTmFullSingle from './svg/acc_tm_full_single.svg';
import accTmFullSingleNew2022 from './svg/acc_tm_full_single_new_2022.svg';
import accTmFullSingleNew2022Black from './svg/acc_tm_full_single_new_2022_black.svg';
import autodesk from './svg/autodesk.svg';
import autodeskAutocadWebSmallBadge from './svg/autodesk_autocad_web_small_badge.svg';
import autodeskBlack from './svg/autodesk_black.svg';
import autodeskFormaLogoBlack from './svg/autodesk_forma_black.svg';
import autodeskFormaLogoWhite from './svg/autodesk_forma_white.svg';
import buildingConstruction from './svg/building_construction.svg';
import buildingConstructionGrey from './svg/building_construction_grey.svg';
import classification from './svg/classification.svg';
import classificationGrey from './svg/classification_grey.svg';
import clipboardConfigureFields from './svg/clipboard_configure_fields.svg';
import clipboardConfigureFieldsGrey from './svg/clipboard_configure_fields_grey.svg';
import clipboardWeather from './svg/clipboard_weather.svg';
import clipboardWeatherGrey from './svg/clipboard_weather_grey.svg';
import computerCharts from './svg/computer_charts.svg';
import computerChartsGrey from './svg/computer_charts_grey.svg';
import contactBinder from './svg/contact_binder.svg';
import contactBinderGrey from './svg/contact_binder_grey.svg';
import craneConstruction from './svg/crane_construction.svg';
import craneConstructionGrey from './svg/crane_construction_grey.svg';
import desktopComputer from './svg/desktop_computer.svg';
import desktopComputerGrey from './svg/desktop_computer_grey.svg';
import envelopeOpen from './svg/envelope_open.svg';
import envelopeOpenGrey from './svg/envelope_open_grey.svg';
import filingCabinet from './svg/filing_cabinet.svg';
import filingCabinetGrey from './svg/filing_cabinet_grey.svg';
import folderEmpty from './svg/folder_empty.svg';
import folderEmptyGrey from './svg/folder_empty_grey.svg';
import folderPdfClosedFist from './svg/folder_pdf_closed_fist.svg';
import folderPdfClosedFistGrey from './svg/folder_pdf_closed_fist_grey.svg';
import folderPhoto from './svg/folder_photo.svg';
import folderPhotoClosedFist from './svg/folder_photo_closed_fist.svg';
import folderPhotoClosedFistGrey from './svg/folder_photo_closed_fist_grey.svg';
import folderPhotoGrey from './svg/folder_photo_grey.svg';
import folderSearch from './svg/folder_search.svg';
import folderSearchGrey from './svg/folder_search_grey.svg';
import folderSheetModel from './svg/folder_sheet_model.svg';
import folderSheetModelGrey from './svg/folder_sheet_model_grey.svg';
import graphs from './svg/graphs.svg';
import graphsGrey from './svg/graphs_grey.svg';
import inventory from './svg/inventory.svg';
import inventoryGrey from './svg/inventory_grey.svg';
import invoiceCheckmark from './svg/invoice_checkmark.svg';
import invoiceCheckmarkGrey from './svg/invoice_checkmark_grey.svg';
import mediaPhoto from './svg/media_photo.svg';
import mediaPhotoGrey from './svg/media_photo_grey.svg';
import nailgun from './svg/nailgun.svg';
import nailgunGrey from './svg/nailgun_grey.svg';
import pageClosedFist from './svg/page_closed_fist.svg';
import pageClosedFistGrey from './svg/page_closed_fist_grey.svg';
import pageListCheckmark from './svg/page_list_checkmark.svg';
import pageListCheckmarkGrey from './svg/page_list_checkmark_grey.svg';
import pagePhoto from './svg/page_photo.svg';
import pagePhotoGrey from './svg/page_photo_grey.svg';
import pagesPhoto from './svg/pages_photo.svg';
import pagesPhotoGrey from './svg/pages_photo_grey.svg';
import pagesQAndA from './svg/pages_q_and_a.svg';
import pagesQAndAGrey from './svg/pages_q_and_a_grey.svg';
import pagesStamps from './svg/pages_stamps.svg';
import pagesStampsGrey from './svg/pages_stamps_grey.svg';
import pagesText from './svg/pages_text.svg';
import pagesTextGrey from './svg/pages_text_grey.svg';
import pdfClosedFist from './svg/pdf_closed_fist.svg';
import pdfClosedFistGrey from './svg/pdf_closed_fist_grey.svg';
import peopleHeads from './svg/people_heads.svg';
import peopleHeadsGrey from './svg/people_heads_grey.svg';
import peopleUpperBody from './svg/people_upper_body.svg';
import peopleUpperBodyGrey from './svg/people_upper_body_grey.svg';
import pictures from './svg/pictures.svg';
import picturesGrey from './svg/pictures_grey.svg';
import roomMeasurements from './svg/room_measurements.svg';
import roomMeasurementsGrey from './svg/room_measurements_grey.svg';
import roomMeasurementsGreyAlt from './svg/room_measurements_grey_alt.svg';
import roomPackage from './svg/room_package.svg';
import roomPackageGrey from './svg/room_package_grey.svg';
import search from './svg/search.svg';
import searchGrey from './svg/search_grey.svg';
import shareDynamicView from './svg/share_dynamic_view.svg';
import shareStaticView from './svg/share_static_view.svg';
import sheet from './svg/sheet.svg';
import sheetAnnotations from './svg/sheet_annotations.svg';
import sheetAnnotationsGrey from './svg/sheet_annotations_grey.svg';
import sheetGrey from './svg/sheet_grey.svg';
import sheetMapPin from './svg/sheet_map_pin.svg';
import sheetMapPinGrey from './svg/sheet_map_pin_grey.svg';
import sheetModel from './svg/sheet_model.svg';
import sheetModelGrey from './svg/sheet_model_grey.svg';
import sheetProjection from './svg/sheet_projection.svg';
import sheetProjectionGrey from './svg/sheet_projection_grey.svg';
import sheetStampPhoto from './svg/sheet_stamp_photo.svg';
import sheetStampPhotoGrey from './svg/sheet_stamp_photo_grey.svg';
import sheetStampSnapshot from './svg/sheet_stamp_snapshot.svg';
import sheetStampSnapshotGrey from './svg/sheet_stamp_snapshot_grey.svg';
import sheetVersions from './svg/sheet_versions.svg';
import sheetVersionsGrey from './svg/sheet_versions_grey.svg';
import sheets from './svg/sheets.svg';
import sheetsGrey from './svg/sheets_grey.svg';
import skyline from './svg/skyline.svg';
import skylineGrey from './svg/skyline_grey.svg';
import speechBubbles from './svg/speech_bubbles.svg';
import speechBubblesGrey from './svg/speech_bubbles_grey.svg';
import speechBubblesInformation from './svg/speech_bubbles_information.svg';
import speechBubblesInformationGrey from './svg/speech_bubbles_information_grey.svg';
import speechBubblesPages from './svg/speech_bubbles_pages.svg';
import speechBubblesPagesGrey from './svg/speech_bubbles_pages_grey.svg';
import tablet from './svg/tablet.svg';
import tabletGrey from './svg/tablet_grey.svg';
import tabletHands from './svg/tablet_hands.svg';
import tabletHandsGrey from './svg/tablet_hands_grey.svg';
import tabletHandsSheet from './svg/tablet_hands_sheet.svg';
import tabletHandsSheetGrey from './svg/tablet_hands_sheet_grey.svg';
import toolbox from './svg/toolbox.svg';
import toolboxGrey from './svg/toolbox_grey.svg';
import toolboxPages from './svg/toolbox_pages.svg';
import toolboxPagesGrey from './svg/toolbox_pages_grey.svg';
import weatherCloudy from './svg/weather_cloudy.svg';
import weatherFog from './svg/weather_fog.svg';
import weatherPartlyCloudy from './svg/weather_partly_cloudy.svg';
import weatherRaindrop from './svg/weather_raindrop.svg';
import weatherRainy from './svg/weather_rainy.svg';
import weatherSleet from './svg/weather_sleet.svg';
import weatherSnow from './svg/weather_snow.svg';
import weatherSnowflake from './svg/weather_snowflake.svg';
import weatherSunny from './svg/weather_sunny.svg';
import weatherWindy from './svg/weather_windy.svg';
import workplace from './svg/workplace.svg';
import workplaceGrey from './svg/workplace_grey.svg';
import workplaceView from './svg/workplace_view.svg';
import workplaceViewGrey from './svg/workplace_view_grey.svg';

const ALLOY_ILLUSTRATIONS: Record<IllustrationType, string> = {
  // Note: In order to preserve name mapping across assets and due to Javascript's
  // inability to define a variable name that starts with a number, we are using
  // string literal keys as a work around.
  '3dModels': _3dModels,
  '3dModelsGrey': _3dModelsGrey,
  accMark,
  accIconBlue,
  accHorizontalGrey,
  accHorizontalWhite,
  accHorizontalWhiteNew2022,
  accTmFullSingle,
  accTmFullSingleNew2022,
  accTmFullSingleNew2022Black,
  autodesk,
  autodeskAutocadWebSmallBadge,
  autodeskBlack,
  autodeskFormaLogoBlack,
  autodeskFormaLogoWhite,
  AUTODESK_WHITE: autodeskBlack,
  buildingConstruction,
  buildingConstructionGrey,
  classification,
  classificationGrey,
  clipboardConfigureFields,
  clipboardConfigureFieldsGrey,
  clipboardWeather,
  clipboardWeatherGrey,
  computerCharts,
  computerChartsGrey,
  contactBinder,
  contactBinderGrey,
  craneConstruction,
  craneConstructionGrey,
  desktopComputer,
  desktopComputerGrey,
  envelopeOpen,
  envelopeOpenGrey,
  filingCabinet,
  filingCabinetGrey,
  folderEmpty,
  folderEmptyGrey,
  folderPdfClosedFist,
  folderPdfClosedFistGrey,
  folderPhoto,
  folderPhotoClosedFist,
  folderPhotoClosedFistGrey,
  folderPhotoGrey,
  folderSearch,
  folderSearchGrey,
  folderSheetModel,
  folderSheetModelGrey,
  graphs,
  graphsGrey,
  inventory,
  inventoryGrey,
  invoiceCheckmark,
  invoiceCheckmarkGrey,
  mediaPhoto,
  mediaPhotoGrey,
  nailgun,
  nailgunGrey,
  pageClosedFist,
  pageClosedFistGrey,
  pageListCheckmark,
  pageListCheckmarkGrey,
  pagePhoto,
  pagePhotoGrey,
  pagesPhoto,
  pagesPhotoGrey,
  pagesQAndA,
  pagesQAndAGrey,
  pagesStamps,
  pagesStampsGrey,
  pagesText,
  pagesTextGrey,
  pdfClosedFist,
  pdfClosedFistGrey,
  peopleHeads,
  peopleHeadsGrey,
  peopleUpperBody,
  peopleUpperBodyGrey,
  pictures,
  picturesGrey,
  roomMeasurements,
  roomMeasurementsGrey,
  roomMeasurementsGreyAlt,
  roomPackage,
  roomPackageGrey,
  search,
  searchGrey,
  shareDynamicView,
  shareStaticView,
  sheet,
  sheetAnnotations,
  sheetAnnotationsGrey,
  sheetGrey,
  sheetMapPin,
  sheetMapPinGrey,
  sheetModel,
  sheetModelGrey,
  sheetProjection,
  sheetProjectionGrey,
  sheetStampPhoto,
  sheetStampPhotoGrey,
  sheetStampSnapshot,
  sheetStampSnapshotGrey,
  sheetVersions,
  sheetVersionsGrey,
  sheets,
  sheetsGrey,
  skyline,
  skylineGrey,
  speechBubbles,
  speechBubblesGrey,
  speechBubblesInformation,
  speechBubblesInformationGrey,
  speechBubblesPages,
  speechBubblesPagesGrey,
  tablet,
  tabletGrey,
  tabletHands,
  tabletHandsGrey,
  tabletHandsSheet,
  tabletHandsSheetGrey,
  toolbox,
  toolboxGrey,
  toolboxPages,
  toolboxPagesGrey,
  weatherCloudy,
  weatherFog,
  weatherPartlyCloudy,
  weatherRaindrop,
  weatherRainy,
  weatherSleet,
  weatherSnow,
  weatherSnowflake,
  weatherSunny,
  weatherWindy,
  workplace,
  workplaceGrey,
  workplaceView,
  workplaceViewGrey,
  firstUse: folderEmptyGrey,
  noChartData: graphsGrey,
  noData: filingCabinetGrey,
  noPermission: toolboxGrey,
  noResults: pagesTextGrey,
  systemError: desktopComputerGrey,
  fileUpload: '',
  undergoingMaintenance: '',
} as const;

export default ALLOY_ILLUSTRATIONS;
